
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

interface PromptFieldProps {
  value: string;
  error: boolean | string;
  setValue: (value: string) => void;
  setError: (error: boolean | string) => void;
  onSubmit: () => void;
  generating: boolean;
  disabled?: boolean;
  [key: string]: unknown;
}

export default function PromptField({
  value,
  error,
  setValue,
  setError,
  onSubmit,
  generating,
  ...rest
}: PromptFieldProps): React.JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    if (newValue === '') {
      setError('Prompt cannot be blank');
    } else {
      setError(false);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.which === 13) {
      //<------use enter key to submit form
      event.preventDefault();
      if (!generating && !rest.disabled) {
        onSubmit();
      }
    }
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          {...rest}
          label='Prompt'
          id='prompt'
          aria-describedby='prompt-helper-text'
          onChange={handleChange}
          error={Boolean(error)}
          onKeyDown={handleKeyDown}
          value={value}
          variant='standard'
          multiline
          disabled={rest.disabled || generating}
        />
        {error ? (
          <FormHelperText id='prompt-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='prompt-helper-text'>
            Enter a question to ask your documents.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

